import { Card, Stack } from '@mui/material'
import { SkeletonText } from 'utoniq-ui'

import { Organism } from '@/core/architecture'

export const OfficialInformationConsoleBoxSkeleton: Organism = () => {
  return (
    <Card elevation={0} sx={{ bgcolor: 'transparent' }}>
      <Stack spacing={2} flex={1}>
        <Stack direction="row" alignItems="center" spacing={2} width="50%">
          <Stack flex={1}>
            <SkeletonText variant="medium" />
          </Stack>
          <Stack flex={4}>
            <SkeletonText variant="medium" />
          </Stack>
        </Stack>
        <SkeletonText variant="large" />
        <SkeletonText variant="large" />
      </Stack>
    </Card>
  )
}
